<div class="site-chrome">
  <header class="topbar" id="start">
    <a class="brand" href="#start" aria-label="Strona główna">
      <img
        class="logo-slot"
        src="assets/logo/optimized/weterynarz-logo-256.webp"
        srcset="assets/logo/optimized/weterynarz-logo-256.webp 256w, assets/logo/optimized/weterynarz-logo-512.webp 512w"
        sizes="(max-width: 768px) 128px, 180px"
        alt="Logo gabinetu weterynaryjnego Waldemar Grzechnik" />
    </a>

    <button
      class="menu-toggle"
      type="button"
      aria-label="Przełącz menu"
      [attr.aria-expanded]="isMobileMenuOpen"
      (click)="toggleMobileMenu()">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <nav class="nav-links" aria-label="Główna nawigacja" [class.is-open]="isMobileMenuOpen">
      <a href="#start" (click)="scrollToTop($event)">Home</a>
      <a href="#onas-heading" (click)="scrollToAnchor('onas-heading', $event)">O nas</a>
      <a href="#zespol-heading" (click)="scrollToAnchor('zespol-heading', $event)">Zespół</a>
      <a href="#uslugi-heading" (click)="scrollToAnchor('uslugi-heading', $event)">Usługi</a>
      <a href="#kontakt-heading" (click)="scrollToAnchor('kontakt-heading', $event)">Kontakt</a>
      <a href="#mapy-heading" (click)="scrollToAnchor('mapy-heading', $event)">Mapy</a>
    </nav>
  </header>

  <main class="page-content">
    <router-outlet></router-outlet>
  </main>

  <footer class="site-footer" aria-label="Stopka serwisu">
    <div class="site-footer-left">
      <span>Wszelkie prawa zastrzeżone</span>
      <span>&copy; {{ currentYear }}</span>
      <a routerLink="/polityka-prywatnosci">Polityka prywatnosci</a>
      <a routerLink="/rodo">RODO</a>
    </div>
    <div class="site-footer-right">
      <span>Wykonanie Sibrica</span>
      <a href="https://www.sibrica.com" target="_blank" rel="noopener noreferrer">www.sibrica.com</a>
    </div>
  </footer>
</div>
